import { TuiIconTdsIllustrationsCommonWiFiOffLight } from '@tui-react/proprietary-icons';
import React from 'react';
import intl from '../../locale';
import { ErrorOverlay } from '../ErrorOverlay';
import { NewOverlay } from '../NewOverlay';

interface InitPollErrorOverlayProps {
  isLoading: boolean;
  isWebview: boolean;
  onClose: () => void;
  onRetry: () => void;
}

export const InitPollErrorOverlay: React.FC<InitPollErrorOverlayProps> = ({
  isLoading,
  isWebview,
  onClose,
  onRetry,
}) => {
  return (
    <NewOverlay
      onClose={onClose}
      isWebview={isWebview}
      onClick={onRetry}
      isLoading={isLoading}
      icon={<TuiIconTdsIllustrationsCommonWiFiOffLight iconSize={160} />}
      title={intl.formatMessage({ id: 'System.InitPollErrorTitle' })}
      description={intl.formatMessage({ id: 'System.InitPollErrorDescription' })}
      buttonText={intl.formatMessage({ id: 'System.InitPollErrorRetry' })}
    />
  );
};

export default ErrorOverlay;
